import { Locale } from '@headless-workspace/config';
import { ConfigByKeyRepository, Result } from '@headless-workspace/core-domain';
import { VipBrandsDTO } from './VipBrandsDTO';
import { mapVipBrands, VipBrandsValue } from './VipBrandsValue';

export interface VipBrandsRepositorySpec {
    fetchVipBrands(locale: Locale): Promise<Result<VipBrandsValue>>;
}

export const VIP_BRANDS_KEY = 'vipBrands';

export class VipBrandsRepository extends ConfigByKeyRepository implements VipBrandsRepositorySpec {
    async fetchVipBrands(locale: Locale): Promise<Result<VipBrandsValue>> {
        return await this.getConfigByKey(VIP_BRANDS_KEY, { locale }, (value) =>
            mapVipBrands(VipBrandsDTO.parse(value), locale),
        );
    }
}
